export default "__VITE_ASSET__BNu9JA68__"